/* eslint-disable indent */
import React, { useState } from 'react';
import { config } from '@/config';
import { LoginPayload } from '@/domains/user/ports/payloads';
import { authService } from '../services/auth.service';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Button, message } from 'antd';
import { getErrorMessage } from '@/components/hooks/useGetErrorMessage';
import { CoreInput } from '@/components/Form/InputAntForm';
import { useNavigate } from 'react-router-dom';
import { AuthenticationBackground } from '../components/AuthenticationBackground';

const schema = yup.object().shape({
  email: yup
    .string()
    .required('Email is required')
    .test('', 'Invalid email', (value) => {
      if (!value) return false;
      return config.regex.username.test(value) || config.regex.email.test(value);
    }),
});

export const UserForgotPassword = (): JSX.Element => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginPayload>({
    resolver: yupResolver(schema),
    defaultValues: {
      email: '',
    },
  });
  const [isSending, setIsSending] = useState(false);
  const navigate = useNavigate();
  const onSubmit = async (input: LoginPayload) => {
    try {
      setIsSending(true);
      await authService.sendPasswordResetEmail(input.email);
      message.success('Password reset email sent successfully');
    } catch (error) {
      message.error(getErrorMessage(error) ?? 'Failed to send password reset email');
    } finally {
      setIsSending(false);
    }
  };

  const buttonStyle = {
    backgroundColor: '#cc1e1e',
    borderColor: '#cc1e1e',
    borderRadius: '8px',
    height: '40px',
    fontSize: '20px',
    fontWeight: 600,
  };

  const inputStyle = {
    borderRadius: '8px',
    height: '40px',
  };

  return (
    <div className='flex flex-col items-center justify-center min-h-screen p-4 bg-gray-100 relative'>
      <AuthenticationBackground />
      <div className='w-full max-w-md p-8 space-y-8 bg-white rounded-lg shadow-md z-100 relative'>
        <div className='flex justify-center mb-6'>
          <img
            src='https://base.mindx.edu.vn/static/images/logo_with_text.svg'
            alt='MindX Logo'
            className='h-12'
          />
        </div>
        <h1 className='text-2xl font-bold text-center'>Forgot Password</h1>
        <form onSubmit={handleSubmit(onSubmit)}>
          <CoreInput
            control={control}
            name='email'
            label='Email'
            required
            placeholder='Enter your email'
            style={inputStyle}
          />
          <Button
            type='primary'
            htmlType='submit'
            className='w-full mt-4 rounded-lg'
            style={buttonStyle}
            loading={isSending}
          >
            Send Reset Email
          </Button>
          <div className='text-center mt-4'>
            <a href='#' className='text-blue-500 text-sm' onClick={() => navigate('/login')}>
              Back to login
            </a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserForgotPassword;
